<mds-spinner
    color="primary"
    class="loading-card"
    mode="indeterminate"
    [diameter]="diameter()"
    [strokeWidth]="6"
></mds-spinner>
